<template>
    <div class="flexbox-fullheight form-view">
        <Modal :config="matchModalConfig">
            <template slot="header">
                {{matchModalHeader}}
            </template>
        </Modal>

    <Modal :config="matchErrorModalConfig">
        <template slot="header">
            Fejl under godkend af match
        </template>
        <template slot="content">
            <div class="form">
                <div class="grid-x align-items">
                    <div class="auto cell border-bottom">
                        <div class="grid-x">
                            <div class="auto cell flexbox-center-left">
                                <div v-for="errorText in matchErrorText" class="relative">                               
                                    <div v-html="errorText">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
        </template>
    </Modal>



        <div v-if="!loading" class="match-container full-height">
            <header class="match-container-header">
                <div class="grid-x">
                    <div class="large-1 medium-2 small-3 cell flexbox-start">
                        <router-link :to="{name: 'dashboard'}">
                            <icon class="arrow-left-circle-svg return-to-dashboard large-svg fill-white stroke-white" name="arrow-left-circle"></icon>
                        </router-link>
                    </div>
                    <div class="large-3 medium-7 small-6 cell flexbox-center-left">
                        <h3>
                            <span>Match af: {{match.projektNr}}</span>
                        </h3>
                        <p style="margin-right: 10px;">{{match.navn}}</p>
                    </div>
                    <div class="large-3 medium-3 small-3 cell flexbox-start">
                        <div class="grid-x grid-margin-x flexbox-center">
                            <div class="large-6 medium-6 small-12 cell">
                                <a class="button button-big" @click="save()">Gem</a>
                            </div>
                            <div class="large-6 medium-6 small-12 cell">
                                <a class="button button-big active-button" @click="approve()">Godkend</a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="match-container-main">
                <div class="grid-x full-height">
                    <div class="large-1 medium-1 small-12 small-cell">
                        &nbsp;
                    </div>
                    <div class="large-7 medium-8 small-12 cell flex">
                        <div style="display: flex; align-items: center;">
                            <div class="tabs" style="flex: 1;">
                                <ul>
                                    <li v-for="(tab, index) in tabs" :key="index" v-if="tab.list.length > 0" @click="setSelectedTab(tab)" :class="{'active': selectedTab === tab}">
                                        {{tab.name}}
                                        <span v-if="tab.id !== 5" class="counter">{{ tab.list.length }}</span>
                                        <span v-else class="counter">{{ match.importLog.length }}</span>
                                    </li>
                                </ul>
                            </div>                                                     
                            <a @click="exportAsExcel()" class="button button-simplified">
                                <icon class="small-svg fill-primary" name="export"></icon>
                                Eksportér
                            </a>                         
                        </div>
                        <!-- header -->
                        <div v-if="selectedTab && selectedTab.id !== 1 && selectedTab && selectedTab.id !== 5" class="grid-x match-container-main-content-header">
                            <div class="large-6 cell">
                                <p>Value</p>
                            </div>
                            <div class="large-1 medium-1 small-2 cell">
                                <p>Match</p>
                            </div>
                            <div class="auto cell">
                                <p>{{ selectedRegnskab.systemKode === 1 ? 'Dandas' : selectedRegnskab.systemKode === 4 ? 'Asset' : '' }}</p>
                            </div>
                        </div>
                        <div v-else-if="selectedTab.id === 5 && selectedTab.list.length <= listFilterThreshold">
                            <p>Viser kun de første {{ listFilterThreshold }} i listen. Hent hele listen gennem eksport funktionen.</p>
                        </div>
                        <div class="match-container-main-content" ref="main">
                            <div class="match-container-main-list-header">
                                <div v-if="selectedTab.id === 1">
                                    <div class="grid-x">
                                        <div class="small-1 small-offset-11 cell" style="display: flex; flex-direction: column; align-items: center;">
                                            <span style="font-size: 0.9rem; margin-bottom: 5px;">Vælg alle</span>
                                            <input type="checkbox" v-model="selectAllStikErstat" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(list, index) in selectedTab.list" :key="index" class="relative">                              
                                <!-- selectedTab === 1 (tilgange) -->
                                <div v-if="selectedTab.id === 1">
                                    <div class="grid-x list">
                                        <div class="large-1 medium-1 small- 1 cell flexbox-center">
                                            <icon class="medium-svg fill-selected-dark-gray" :title='list.importAktivTypeKode | translateImportAktivType' :name="list | translateImportAktivTypeToIcon"></icon>
                                        </div>
                                        <div class="large-2 medium-3 small-3 cell truncate-fade-gray">
                                            <span :title="list.navn">{{list.navn}}</span><br />
                                            <span :title="list.aktivKategoriNavn">{{list.aktivKategoriNavn ? list.aktivKategoriNavn : 'Intet navn'}}</span>
                                        </div>                                        
                                        <div class="large-7 medium-5 small-5 cell truncate-fade-gray">
                                            <div class="flexbox">
                                                <div>
                                                    <span :title="list.beskrivelse">{{list.beskrivelse}}</span>
                                                </div>
                                            </div>
                                            <span :title="list.detaljeretBeskrivelse">{{list.detaljeretBeskrivelse}}</span>
                                        </div>
                                        
                                        <div v-if="list.geoJson" class="large-1 medium-1 small-1 cell flexbox-center">
                                            <div class="cursor button-highlight flexbox-center" @click="setLocationMap(list)">
                                                <icon class="small-medium-svg fill-selected-dark-gray" name="location"></icon>
                                            </div>
                                        </div>
                                        <div class="large-1 medium-1 small-1 cell flexbox-center">
                                            <input type="checkbox" v-if="list.kanStikErstat === 1" v-model="selectedStikErstats" :value="list.id" :true-value="1" :false-value="0" style="margin: 0px;">
                                        </div>
                                    </div>
                                </div>

                                <!-- selectedTab = 2 (afgange) -->
                                <div v-if="selectedTab.id === 2" class="list">
                                    <div class="grid-x margin-list">
                                        <!-- match -->
                                        <div class="large-6 cell">
                                            <div v-for="(match, midx) in selectedImportMatch(list)" :key="midx" class="grid-x">
                                                <div class="large-1 medium-1 small-1 cell flexbox-center">
                                                    <icon class="medium-svg fill-selected-dark-gray" :title='list.importAktivTypeKode | translateImportAktivType' :name="list | translateImportAktivTypeToIcon"></icon>
                                                </div>
                                                <div class="large-5 medium-4 small-4 cell truncate-fade-gray">
                                                    <span :title="match.Navn">{{match.Navn}}</span><br />
                                                    <span :title="match.EksternId">{{match.EksternId}}</span>
                                                </div>
                                                <div class="large-6 medium-5 small-5 cell">
                                                    <div class="flexbox truncate-fade-gray">
                                                        <div>
                                                            <span :title="match.Beskrivelse">{{match.Beskrivelse}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div v-if="list.importMatch.length > 1" class="large-1 medium-1 small-1 cell flexbox-center-left" @click="toggleDropdown(list.importMatch, index, list.eksternId)">
                                                    <icon class="medium-svg cursor fill-white" name="keyboard_arrow_sort"></icon>
                                                </div> -->
                                            </div>
                                        </div>
                                        <!-- icon -->
                                        <div class="large-1 medium-1 small-1 cell flexbox-center-left">
                                            <div class="match-icon asset singleList">
                                                <icon class="large-svg fill-medium-gray" name="match"></icon>
                                            </div>
                                        </div>
                                        <!-- list -->
                                        
                                        <div class="auto cell">
                                            <div class="grid-x">
                                                <div class="large-1 medium-1 small-1 cell flexbox-center">
                                                    <icon class="medium-svg fill-selected-dark-gray" :title='list.importAktivTypeKode | translateImportAktivType' :name="list | translateImportAktivTypeToIcon"></icon>
                                                </div>
                                                <div class="large-4 medium-4 small-4 cell truncate-fade-gray">
                                                    <span :title="list.eksternId">{{list.eksternId}}</span><br />
                                                    <span :title="list.navn">{{list.navn}}</span>
                                                </div>
                                                <div class="large-6 medium-6 small-6 cell truncate-fade-gray">
                                                    <div class="flexbox">
                                                        <div>
                                                            <span :title="list.beskrivelse">{{list.beskrivelse}}</span>
                                                        </div>
                                                    </div>
                                                    <span :title="list.detaljeretBeskrivelse">{{list.detaljeretBeskrivelse}}</span>
                                                </div>
                                                <div v-if="list.feature && list.geoJson" @click="setLocationMap(list)" class="large-1 medium-1 small-1 cell flexbox-center cursor button-highlight">
                                                    <icon class="small-medium-svg fill-selected-dark-gray" name="location"></icon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="list.importLog && list.importLog.length > 0" v-for="(log, lidx) in list.importLog" :key="lidx" class="grid-x info-list">
                                        <div class="large-12 cell">
                                            <icon class="small-svg fill-selected-dark-gray" name="info-with-circle"></icon>
                                            <span class="info-box">{{log.Beskrivelse}}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- selectedTab === 3 (ændringer) -->
                                <div v-if="selectedTab.id === 3 && list.slettet !== 1" class="list">
                                    <div class="grid-x margin-list">
                                        <div class="large-6 cell flexbox-center-left">
                                            <div v-for="(match, midx) in selectedImportMatch(list)" :key="midx" class="grid-x">
                                                <div v-if="match.Id" class="grid-x" style="width: 100%">
                                                    <div class="large-1 medium-1 small-1 cell flexbox-center">
                                                        <icon class="medium-svg fill-selected-dark-gray" :title='list.importAktivTypeKode | translateImportAktivType' :name="list | translateImportAktivTypeToIcon"></icon>
                                                    </div>
                                                    <div class="large-5 medium-4 small-4 cell truncate-fade-gray">
                                                        <span :title="match.Navn">{{match.Navn}}</span><br />
                                                        <span :title="match.EksternId">{{match.EksternId}}</span>
                                                    </div>
                                                    <div class="large-5 cell truncate-fade-gray">
                                                        <div class="flexbox">
                                                            <div>
                                                                <span :title="match.Beskrivelse">{{match.Beskrivelse}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div @click="toggleDropdown(list.importMatch, index, list.eksternId)" class="large-1 medium-2 small-2 cell flexbox-center-left">
                                                        <icon class="medium-svg cursor fill-white" name="keyboard_arrow_sort"></icon>
                                                    </div> -->
                                                </div>
                                                <div v-else class="grid-x" style="height: 45px; width: 100%;">
                                                    <div class="large-11 medium-10 small-10 cell text-center">
                                                        <span>Ingen match</span><br />
                                                        <span>Skift match i dropdown</span>
                                                    </div>
                                                    <!-- <div @click="toggleDropdown(list.importMatch, index, list.eksternId)" class="large-1 medium-1 small-1 cell flexbox-center-left">
                                                        <icon class="medium-svg cursor fill-white" name="keyboard_arrow_sort"></icon>
                                                    </div> -->
                                                    <div class="large-1 medium-1 small-1 cell"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="large-1 medium-1 small-1 cell flexbox-center-left relative">
                                            <div class="match-icon asset singleList">
                                                <icon class="large-svg fill-medium-gray" name="match"></icon>
                                            </div>
                                        </div>
                                        <div class="auto cell">
                                            <div class="grid-x">
                                                <div class="large-1 medium-1 small-1 cell flexbox-center">
                                                    <icon class="medium-svg fill-selected-dark-gray" :title='list.importAktivTypeKode | translateImportAktivType' :name="list | translateImportAktivTypeToIcon"></icon>
                                                </div>
                                                <div class="large-4 medium-4 small-4 cell truncate-fade-gray">
                                                    <span :title="list.navn">{{list.navn}}</span><br />
                                                    <span :title="list.eksternId">{{list.eksternId}}</span>
                                                </div>
                                                <div class="large-5 medium-7 small-7 cell truncate-fade-gray">
                                                    <div class="flexbox">
                                                        <div>
                                                            <span :title="list.beskrivelse">{{list.beskrivelse}}</span>
                                                        </div>
                                                    </div>
                                                    <span :title="list.detaljeretBeskrivelse">{{list.detaljeretBeskrivelse}}</span>
                                                </div> 
                                                <div v-if="list.geoJson" class="large-1 medium-1 small-1 cell flexbox-center cursor button-highlight" @click="setLocationMap(list)">
                                                    <icon class="small-medium-svg fill-selected-dark-gray" name="location"></icon>
                                                </div>
                                                <div v-if="selectedRegnskab.systemKode === 4" class="large-1 medium-1 small-1 cell flexbox-center cursor button-highlight" style="margin-left: 5px;" @click="deleteAssetMatchRow(list, match)">
                                                    <icon class="small-medium-svg fill-selected-dark-gray" name="delete"></icon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="(log, lidx) in list.importLog" :key="lidx" class="grid-x info-list">
                                        <div class="large-12 cell">
                                            <icon class="small-svg fill-selected-dark-gray" name="info-with-circle"></icon>
                                            <span class="info-box">{{log.Beskrivelse}}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- selectedTab === 4 (tekniske ændringer) -->
                                <div v-if="selectedTab.id === 4 && technicalMatchAlreadyExist(list)" class="list">
                                    <div class="grid-x margin-list">
                                        <div class="large-6 cell flexbox-center-left">
                                            <div v-for="(match, midx) in list.importMatch" :key="midx" class="grid-x custom-list">
                                                <div class="large-1 medium-1 small-1 cell flexbox-center">
                                                    <!-- <icon class="medium-svg fill-selected-dark-gray" :title='match.importAktivTypeKode | translateImportAktivType' :name="list | translateImportAktivTypeToIcon(3)"></icon> -->
                                                </div>
                                                <div class="large-5 medium-4 small-4 cell truncate-fade-gray flexbox-center-left">
                                                    <span :title="match.Navn">{{match.Navn}}</span>
                                                    <span :title="match.EksternId">{{match.EksternId}}</span>
                                                </div>
                                                <div class="large-6 medium-5 small-5 cell truncate-fade-gray">
                                                    <div class="flexbox">
                                                        <div>
                                                            <span :title="match.Beskrivelse">{{match.Beskrivelse}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="large-1 medium-1 small-1 cell flexbox-center-left">
                                            <div class="asset multipleList" :class="{'match-icon': list.importMatch.length === getLengthOfImportAktiver(list)}">
                                                <icon :class="{'big-custom-match-2-svg': list.importMatch.length < 3 ||  getLengthOfImportAktiver(list) < 3, 'big-custom-match-3-svg': list.importMatch.length === 3 || getLengthOfImportAktiver(list) === 3}" class="big-custom-match-svg fill-medium-gray" :name="matchIcon(list)"></icon>
                                            </div>
                                        </div>
                                        <div class="auto cell flexbox-center-left relative">
                                            <div v-for="(importAktiv, iidx) in getMatchList(list)" :key="iidx" class="grid-x custom-list">
                                                <div class="large-1 medium-1 small-1 cell flexbox-center">
                                                    <icon class="medium-svg fill-selected-dark-gray" :title='importAktiv.importAktivTypeKode | translateImportAktivType' :name="importAktiv | translateImportAktivTypeToIcon"></icon>
                                                </div>
                                                <div class="large-5 medium-4 small-4 cell truncate-fade-gray">
                                                    <span :title="importAktiv.navn">{{importAktiv.navn}}</span><br />
                                                    <span :title="importAktiv.eksternId">{{importAktiv.eksternId}}</span>
                                                </div>
                                                <div class="large-4 medium-6 small-6 cell truncate-fade-gray">
                                                    <div class="flexbox">
                                                        <div>
                                                            <span :title="importAktiv.beskrivelse">{{importAktiv.beskrivelse}}</span>
                                                        </div>
                                                    </div>
                                                    <span :title="importAktiv.detaljeretBeskrivelse">{{importAktiv.detaljeretBeskrivelse}}</span>
                                                </div>
                                                <div v-if="list.geoJson" class="large-1 medium-1 small-1 cell cursor match-icon-position" @click="setLocationMap(list)">
                                                    <icon class="small-medium-svg fill-selected-dark-gray" name="location"></icon>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="(log, lidx) in list.importLog" :key="lidx" class="grid-x info-list">
                                        <div class="large-12 cell">
                                            <icon class="small-svg fill-selected-dark-gray" name="info-with-circle"></icon>
                                            <span class="info-box">{{log.Beskrivelse}}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- selectedTab === 5 (uændret) -->
                                <div v-if="selectedTab.id === 5" class="list">
                                    <div class="grid-x">
                                        <div class="large-1 medium-1 small-1 cell">
                                            <icon class="medium-svg fill-selected-dark-gray" :name="list.type | translateLogTypeToIcon"></icon>
                                        </div>
                                        <div class="large-11 medium-11 small-11 cell flex-center" :title="list.beskrivelse">
                                            <span>{{list.beskrivelse ? list.beskrivelse : 'Ingen beskrivelse'}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="showDropdown && dropdownIndex === index" class="dropdown-list">
                                    <div v-if="!alt.message" v-for="alt in alternatives" :key="alt.Id" @click="setAlternative(alt)" class="grid-x dropdown-item">
                                        <div class="large-1 cell flexbox-center">
                                            <icon class="medium-svg fill-selected-dark-gray" :title='list.ImportAktivTypeKode | translateImportAktivType' :name="list | translateImportAktivTypeToIcon"></icon>
                                        </div>
                                        <div class="large-5 medium-5 small-5 cell truncate-fade" :title="alt.navn">
                                            <span>{{alt.Navn}}</span><br />
                                            <span>{{alt.EksternId}}</span>
                                        </div>
                                        <div class="large-5 medium-5 small-5 cell truncate-fade">
                                            <span :title="alt.Beskrivelse">{{alt.Beskrivelse}}</span><br />
                                        </div>
                                    </div>
                                    <div v-else @click="setAlternative(alt)" class="grid-x text-center big-dropdown">
                                        <span><icon class="medium-svg fill-selected-dark-gray" name="cancel-1"></icon> {{alt.message}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="auto cell">
                        <nmap :config="mapConfig" @mounted="mapLoaded"/>
                    </div>
                </div>
            </main>
        </div>
        <div v-else class="loading-div">
            <h1 class="loading-header">Henter match...</h1>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from '@/store/api.js'
import Modal from '@/components/modal/modal.vue'
import { ModalConfig } from '@/components/modal/modal.js'
import { NMap, NMapConfig, NMapUtils, NMapStyle, NMapStyleCircle, NMapLayerControl, NMapLayerEsriWorldImagery, NMapLayerOpenStreetMap, NMapLayerVector, NMapBoundingBox, NMapCoordinates, NMapFeature } from 'ncomponents-map'

let technicalChangesList = []

export default {
    name: 'match',
    components: {
        Modal,
        nmap: NMap
    },
    data () {
        return {
            loading: false,
            matchErrorModalConfig: null,
            matchErrorText: [],
            matchModalConfig: null,
            matchModalHeader: '',
            match: {},
            tabs: [],
            selectedTab: null,
            showDropdown: false,
            dropdownIndex: null,
            alternatives: [],
            matches: [],
            // map
            mapConfig: null,
            mapLayers: {
                highlightLayer: null,
                featureLayer: null
            },
            selectedStikErstats: [],
            listFilterThreshold: 1000
        }
    },
    computed: {
        ...mapGetters({
            selectedRegnskab: 'getSelectedRegnskab'
        }),
        selectAllStikErstat: {
            get: function () {
                return this.selectedTab.list ? this.selectedStikErstats.length === this.selectedTab.list.filter(r => r.kanStikErstat).length : false
            },
            set: function (value) {
                var selected = []

                if (value) {
                    this.selectedTab.list.forEach(function (row) {
                        if (row.kanStikErstat) {
                            selected.push(row.id)
                        }
                    })
                }
                this.selectedStikErstats = selected
            }
        }
    },
    methods: {
        selectedImportMatch (list) {
            let matches = list.importMatch.filter(item => item.ValgtAlternativ === 'J')
            if (this.selectedTab.id === 3 && matches.length === 0) {
                let object = {}
                matches.push(object)
                return matches
            } else {
                return matches
            }
        },
        toggleDropdown (matches, index, eksternId) {
            if (this.selectedTab.id === 2) {
                if (index !== this.dropdownIndex) {
                    this.alternatives = matches.filter(match => match.ValgtAlternativ === 'N')
                    console.log('alternatives', this.alternatives)
                    this.dropdownIndex = index
                    this.showDropdown = true
                    this.matches = matches
                } else {
                    if (this.showDropdown) {
                        this.resetDropdown()
                    } else {
                        this.alternatives = matches.filter(match => match.ValgtAlternativ === 'N')
                        this.dropdownIndex = index
                        this.showDropdown = true
                        this.matches = matches
                    }
                }
            } else {
                if (index !== this.dropdownIndex) {
                    let alternatives = matches.filter(match => match.ValgtAlternativ === 'N')
                    if (alternatives.length !== matches.length) {
                        let object = {message: 'Ingen match'}
                        alternatives.push(object)
                    }
                    this.alternatives = alternatives
                    this.dropdownIndex = index
                    this.showDropdown = true
                    this.matches = matches
                } else {
                    if (this.showDropdown) {
                        this.resetDropdown()
                    } else {
                        let alternatives = matches.filter(match => match.ValgtAlternativ === 'N')
                        if (alternatives.length !== matches.length) {
                            let object = {message: 'Ingen match'}
                            alternatives.push(object)
                        }
                        this.alternatives = alternatives
                        this.dropdownIndex = index
                        this.showDropdown = true
                        this.matches = matches
                    }
                }
            }
        },
        resetDropdown () {
            this.showDropdown = false
            this.dropdownIndex = null
            this.alternatives = []
            this.matches = []
        },
        setAlternative (alt) {
            if (this.selectedTab.id === 2) {
                this.matches.forEach(match => {
                    if (match === alt) {
                        match.ValgtAlternativ = 'J'
                    } else {
                        match.ValgtAlternativ = 'N'
                    }
                })
            } else {
                if (alt.message) {
                    this.matches.forEach(match => {
                        match.ValgtAlternativ = 'N'
                    })
                    // vis Ingen match
                } else {
                    this.matches.forEach(match => {
                        if (match === alt) {
                            match.ValgtAlternativ = 'J'
                        } else {
                            match.ValgtAlternativ = 'N'
                        }
                    })
                }
            }
            this.resetDropdown()
        },
        getLengthOfImportAktiver (importAktiv) {
            let length = 0
            let array = []
            importAktiv.importMatch.forEach(match => {
                array.push(match.AktivId)
            })
            this.selectedTab.list.forEach(item => {
                item.importMatch.forEach(iMatch => {
                    if (array.indexOf(iMatch.AktivId) > -1) {
                        length += 1
                    }
                })
            })
            if (length === 0) {
                length = 1
            }
            return length
        },
        async save (approve) {
            try {
                if (!approve) {
                    this.matchModalHeader = 'Gemmer...'
                    this.matchModalConfig.open()
                }

                this.match.importAktivs.forEach(aktiv => {
                    if (aktiv.importMatch && aktiv.importMatch.length > 0) {
                        aktiv.importMatch = aktiv.importMatch.filter(m => m.ValgtAlternativ === 'J')
                    }
                    aktiv.stikErstat = this.selectedStikErstats.includes(aktiv.id) ? 1 : 0
                })

                const response = await axios.post('/Value/Project/UpdateProject', this.match)
                if (response) {
                    this.match = response.data
                }
                if (!approve) {
                    this.matchModalConfig.close()
                }
            } catch (err) {
                this.matchModalHeader = 'Der skete en fejl. Prøv igen'
                setTimeout(() => {
                    this.matchModalConfig.close()
                }, 2500)
                console.log('error saving match', err)
            }
        },
        async approve () {
            try {
                this.matchModalHeader = 'Godkender...'
                this.matchModalConfig.open()
                await this.save('approve')

                const response = await axios.post('/value/Project/AproveMatchning', {
                    anlaegsProjektId: this.match.id,
                    regnskabId: this.match.regnskabId
                })
                this.matchModalConfig.close()
                if (!response.data) {
                    this.$router.push({
                        name: 'projectid',
                        params: {
                            id: this.match.id
                        }
                    })
                } else {
                    this.matchErrorText = response.data
                    this.matchErrorModalConfig.open()
                    console.log('Fejl under match', response.data)
                }
            } catch (err) {
                this.matchModalHeader = 'Der skete en fejl. Prøv igen'
                setTimeout(() => {
                    this.matchModalConfig.close()
                }, 2500)
                console.log('error approving match', err)
            }
        },
        setSelectedTab (tab) {
            this.selectedTab = tab
            technicalChangesList = []
            this.resetDropdown()
            this.$refs.main.scrollTop = 0
        },
        setLocationMap (match) {
            this.mapLayers.highlightLayer.clear()
            this.mapConfig.fit(match.feature, {maxZoom: 20})
            this.mapLayers.highlightLayer.addFeature(new NMapFeature({
                sourceType: 'wktFeature',
                source: match.wkt,
                projection: 'EPSG:25832',
                style: match.mapStyle === 'spild_broend'
                    ? new NMapStyleCircle({
                        fillOpacity: 0,
                        strokeColor: 'orange',
                        strokeOpacity: 0.6,
                        strokeWidth: 9
                    })
                    : new NMapStyle({
                        strokeColor: 'orange',
                        strokeOpacity: 0.6,
                        strokeWidth: 9
                    })
            }))

            this.mapLayers.highlightLayer.addFeature(new NMapFeature({
                sourceType: 'wktGeometry',
                source: match.wkt,
                projection: 'EPSG:25832',
                style: this.getFeatureStyle(match)
            }))
        },
        deleteAssetMatchRow (row) {
            const selectedMatch = this.selectedTab.list.find(s => s.id === row.id)
            selectedMatch.slettet = 1
        },
        matchIcon (list) {
            const lengthOfImportAktiver = this.getLengthOfImportAktiver(list)
            if (list.importMatch.length > lengthOfImportAktiver) {
                if (list.importMatch.length > 3) {
                    return 'match-lesser-3'
                }
                return 'match-lesser-' + list.importMatch.length
            } else if (list.importMatch.length < lengthOfImportAktiver) {
                if (lengthOfImportAktiver > 3) {
                    return 'match-greater-3'
                }
                return 'match-greater-' + lengthOfImportAktiver
            } else {
                return 'match'
            }
        },
        technicalMatchAlreadyExist (importAktiv) {
            if (technicalChangesList.indexOf(importAktiv) > -1) {
                return false
            }
            return true
        },
        getMatchList (tekniskImportAktiv) {
            let array = []
            let matchArray = []

            if (tekniskImportAktiv.importMatch !== null && (tekniskImportAktiv.samle === 1 || tekniskImportAktiv.erstat === 1 || tekniskImportAktiv.stikErstat === 1)) {
                tekniskImportAktiv.importMatch.forEach(match => {
                    array.push(match.AktivId)
                })

                this.tabs.find(tab => tab.name === 'Tekniske ændringer').list.forEach(tekniskÆndring => {
                    tekniskÆndring.importMatch.forEach(match => {
                        if (array.indexOf(match.AktivId) > -1) {
                            matchArray.push(tekniskÆndring)
                            technicalChangesList.push(tekniskÆndring)
                        }
                    })
                })

                if (matchArray.length === 0) {
                    matchArray.push(tekniskImportAktiv)
                    technicalChangesList.push(tekniskImportAktiv)
                }
            }
            return matchArray
        },
        mapLoaded () {
            if (this.mapLayers.featureLayer) {
                this.mapConfig.fit(this.mapLayers.featureLayer)
            } else {
                this.mapConfig.fit(new NMapBoundingBox(
                    new NMapCoordinates(8.08997684086, 54.8000145534, 'EPSG:4326'),
                    new NMapCoordinates(12.6900061378, 57.730016588, 'EPSG:4326')
                ))
            }
        },
        populateMap () {
            if (this.match.importAktivs.length > 0) {
                this.mapLayers.featureLayer = new NMapLayerVector({
                    hidden: true
                })
                this.mapConfig.addLayer(this.mapLayers.featureLayer)
                this.mapLayers.highlightLayer = new NMapLayerVector({
                    hidden: true
                })
                this.mapConfig.addLayer(this.mapLayers.highlightLayer)
                this.match.importAktivs.forEach(match => {
                    if ((match.wkt !== null) && (match.wkt.length > 0)) {
                        const feature = new NMapFeature({
                            sourceType: 'wktGeometry',
                            source: match.wkt,
                            projection: 'EPSG:25832',
                            style: this.getFeatureStyle(match)
                        })
                        this.mapLayers.featureLayer.addFeature(feature)
                        match.feature = feature
                    }
                })
            }
        },
        getFeatureStyle (item) {
            let style = new NMapStyle({
                strokeWidth: 2
            })
            switch (item.mapStyle) {
            case 'spild_spildevandsledning':
                style.strokeColor = 'red'
                break

            case 'spild_regnvandsledning':
                style.strokeColor = 'blue'
                style.strokeDash = [10, 10]
                break

            case 'spild_faellesledning':
                style.strokeColor = 'green'
                style.strokeDash = [25, 10]
                break

            case 'spild_draenledning':
                style.strokeColor = 'pink'
                style.strokeDash = [25, 10]
                break

            case 'spild_trykledning-spildevand':
                style.strokeColor = 'red'
                style.strokeDash = [20, 10, 6, 10]
                break

            case 'spild_trykledning-regnvand':
                style.strokeColor = 'blue'
                style.strokeDash = [20, 10, 6, 10]
                break

            case 'spild_nedlagtledning':
                style.strokeColor = 'yellow'
                style.strokeDash = [20, 10, 8, 10]
                break

            case 'spild_broend':
                style = new NMapStyleCircle({
                    fillOpacity: 0,
                    strokeColor: 'black'
                })
                break

            default:
                style.strokeColor = 'black'
                break
            }

            return style
        },
        async exportAsExcel () {
            try {
                const response = await axios.downloadExcel('/Value/Export/ExportProjekt ', {id: this.match.id, balanceId: null})
                if (response) {
                    return new Promise((resolve, reject) => {
                        let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, 'Projekt.xlsx')
                            resolve(blob)
                        }

                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob, 'Projekt.xlsx')
                        link.download = 'Projekt.xlsx'
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)

                        resolve(blob)
                    })
                }
            } catch (err) {
                throw err
            }
        }
    },
    async created () {
        try {
            if (this.$route.params.id) {
                this.loading = true

                NMapUtils.registerProjection('EPSG:25832', '+proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs')
                this.mapConfig = new NMapConfig()
                this.mapConfig.addButton(new NMapLayerControl({
                    map: this.mapConfig
                }))
                this.mapConfig.addLayer(new NMapLayerOpenStreetMap())
                this.mapConfig.addLayer(new NMapLayerEsriWorldImagery({
                    visible: false
                }))

                this.tabs = [
                    {
                        id: 1,
                        name: 'Tilgange',
                        list: []
                    },
                    {
                        id: 3,
                        name: 'Ændringer',
                        list: []
                    },
                    {
                        id: 4,
                        name: 'Tekniske ændringer',
                        list: []
                    },
                    {
                        id: 2,
                        name: 'Afgange',
                        list: []
                    },
                    {
                        id: 5,
                        name: 'Uændret',
                        list: []
                    }
                ]

                const response = await axios.post('/Value/Project/ReadProjectDetailsById', {
                    id: this.$route.params.id,
                    balanceId: null
                })
                if (response) {
                    this.match = response.data

                    if (this.match.importAktivs && this.match.importAktivs.length > 0) {
                        this.match.importAktivs.forEach(aktiv => {
                            if (!aktiv.hasOwnProperty('slettet')) {
                                this.$set(aktiv, 'slettet', 0)
                            }
                            if (aktiv.importMatch === null && aktiv.samle !== 1 && aktiv.erstat !== 1) {
                                // tilgang
                                this.tabs[0].list.push(aktiv)
                            } else if (aktiv.importMatch !== null && aktiv.afgang !== 1 && aktiv.samle !== 1 && aktiv.erstat !== 1 && aktiv.stikErstat !== 1) {
                                // Ændring
                                this.tabs[1].list.push(aktiv)
                            } else if (aktiv.importMatch !== null && (aktiv.samle === 1 || aktiv.erstat === 1 || aktiv.stikErstat === 1)) {
                                // Teknisk ændring
                                this.tabs[2].list.push(aktiv)
                            } else if (aktiv.importMatch !== null && aktiv.afgang === 1 && aktiv.samle !== 1 && aktiv.erstat !== 1 && aktiv.stikErstat !== 1) {
                                // Afgang
                                this.tabs[3].list.push(aktiv)
                            }
                        })
                    }

                    if (this.match.importLog && this.match.importLog.length > 0) {
                        this.match.importLog.forEach((log, index) => {
                            // uændret
                            if (index < this.listFilterThreshold) {
                                this.tabs[4].list.push(log)
                            }
                        })
                    }

                    this.selectedTab = this.tabs.find(tab => tab.list.length > 0)

                    this.populateMap()
                }

                this.matchErrorModalConfig = new ModalConfig({
                    reject: 'Luk vindue'
                })

                this.matchModalConfig = new ModalConfig({})
                this.loading = false
            } else {
                this.$router.push({
                    name: 'dashboard'
                })
            }
        } catch (err) {
            console.log('error getting match', err)
        }
    }
}
</script>

<style lang="scss" scoped>
.match-container {
    display: flex;
    flex-direction: column;

    .match-container-header {
        flex: 0 0 auto;
        justify-content: center;
        padding: 20px 0;
        background-color: #367abd;
        color: #fff;
        height: 160px;
        max-height: 160px;
        z-index: 999;

        .flexbox-start {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .flexbox-center-left {
            display: flex;
            justify-content: center;
            flex-direction: column;
            text-align: left;
        }

        h3 {
            font-weight: 400;
            margin-bottom: 10px;

            span {
                margin-bottom: 10px;
                border-bottom: 1px solid #fff;
            }
        }
    }

    .match-container-main {
        .small-cell {
            width: 4%;
        }

        .match-container-main-content-header {
            width: 92%;
        }
        
        .match-container-main-content-header .cell:nth-of-type(odd) p {
            text-align: center;
            color: #367abd;
        }

        .match-container-main-content-header .cell p {
            font-weight: bold;
            text-transform: uppercase;
            color: #367abd;
            font-size: 1.2rem;
        }

        .flex {
            display: flex;
            flex-direction: column;

            .tabs {
                flex: 0 0 auto;
            }

            .match-container-main-content {
                flex: 1 1 0;
                overflow-y: auto;
                padding-top: 15px;
                min-width: 800px;
                padding-right: 15px;
            }
        }
    }
}

.button-highlight {
    border: 1px solid #eee;
    height: 35px;
    max-width: 35px;
    transition: .3s all ease;
    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

    &:hover {
        background-color: #367ABD;
        border-color: #367ABD;

        svg {
            fill: #fff !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/match.vue